import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

// FIQ-1554: stamps for the data-change banner - read only, never triggers anything
export const getMappingFreshness = api(async function getMappingFreshness(registerId) {
    return registerId
        ? query(
              gql`
                  query GetMappingFreshness($registerId: String!) {
                      getMappingFreshness(registerId: $registerId)
                  }
              `,
              { registerId },
              { returns: "getMappingFreshness" }
          )
        : undefined
})
